// Geteilt zwischen AnalyticsPage.tsx (Schule-Sektion) und UserDetailPage.tsx
// (Schule & Stundenplan-Karte) — beide zeigen dieselben Backend-Enums
// (Prisma SchoolSync / SchoolScheduleSource), eine Kopie statt Import hätte
// bei einer Label-Änderung nur eine der beiden Stellen getroffen.

export const SCHOOL_SYNC_LABELS: Record<string, string> = {
  PREPARE: 'Vorbereitung',
  REVIEW: 'Nachbereitung',
  BOTH: 'Vorbereitung + Nachbereitung',
  unbekannt: 'Unbekannt',
};

export const SCHEDULE_SOURCE_LABELS: Record<string, string> = {
  ICS_UPLOAD: 'ICS-Datei',
  AI_VISION: 'KI-Analyse (Foto/PDF)',
  APPLE_CALENDAR: 'Apple-Kalender',
  MANUAL: 'Manuell angelegt',
  unbekannt: 'Unbekannt',
};
